import { gql } from '@apollo/client';

export const PARTNER_DOWNLOAD_SURVEY_PARTNER_DETAILS = gql`
    query Obt_DownloadSurveyPartnerData($criteria: IObtSurveySearchCriteriaInput!) {
        obtDownloadSurveyPartnerData(criteria: $criteria) {
            surveyList {
                surveyId
                waveId
                partnerNo
                systemCode
                masterPartnerNo
                partnerName
                category
                companyCode
                countryCode
                otSurveyStatus
                surveyStatus
                surveyType
                surveyRequest
                masterDataAcceptedDate
                channelDataAcceptedDate
                agreementStatusDate
                provisionalGoLiveDate
                confirmedGoLiveDate
                surveySubmissionDate
                surveySentDate
                surveySentToProvider
                dateSurveySentToProvider
                assignedPartnerUserId
                agreementDownloaded
                agreementStatusId
                agreementApproverName
                insertTime
                masterDataInsertTime
                updateTime
                technicalContactName
                technicalContactEmail
                technicalContactPhoneNumber
                connectivityInfoDate
                surveyActiveStatus
                agreementType
                assignedPartnerUserName
                remark
                partnerId
                apArPartnerLink
            }
            total
        }
    }
`;

export const PARTNER_DOWNLOAD_SURVEY_PARTNER_CONTACT_DETAILS = gql`
    query Obt_DownloadSurveyPartnerContactDetails($criteria: DownloadSurveyPartnerContactInput!) {
        obtDownloadSurveyPartnerContactDetails(criteria: $criteria) {
            id
            partnerno
            idpartner
            companycode
            role
            mail
            source
            valid
            name1
            name2
            department
            phone
            fax
            error
            anlageUser
            anlageDatum
            aenderungUser
            aenderungDatum
        }
    }
`;

export const PARTNER_DOWNLOAD_SURVEY_PARTNER_CHANNEL_DETAILS = gql`
    query Obt_DownloadSurveyPartnerChannelDetails($criteria: DownloadSurveyPartnerChannelInput!) {
        obtDownloadSurveyPartnerChannelDetails(criteria: $criteria) {
            id
            partnerno
            idpartner
            companycode
            invprocess
            validfrom
            validto
            status
            channeltype
            direction
            format
            count
            provider
            newProcess
            anlageUser
            anlageDatum
            aenderungUser
            aenderungDatum
        }
    }
`;

export const PARTNER_DOWNLOAD_SURVEY_EXCEL = gql`
    query Obt_DownloadSurveyExcel($criteria: IObtSurveySearchCriteriaInput!) {
        obtDownloadSurveyExcel(criteria: $criteria)
    }
`;

export const GQL_PARTNER_DOWNLOAD = {
    queries: {
        PARTNER_DOWNLOAD_SURVEY_PARTNER_DETAILS,
        PARTNER_DOWNLOAD_SURVEY_PARTNER_CONTACT_DETAILS,
        PARTNER_DOWNLOAD_SURVEY_PARTNER_CHANNEL_DETAILS,
        PARTNER_DOWNLOAD_SURVEY_EXCEL,
    },
};
